import * as T from './reportFiltersTypes';
import type { ReportFiltersAction } from './reportFiltersActions';

export interface ReportFiltersState {
  /** Preset ('Today' | 'Yesterday' | '7D' | '30D' | 'This Month') or 'custom:YYYY-MM-DD:YYYY-MM-DD'. */
  dateFilter: string;
  /**
   * ZAR-2371 — Channel / Source toggle on the Sales by Channel card. Kept here (not in the
   * screen) so the choice survives navigating away and back, and so Snapshot and Sales agree.
   */
  salesBreakdownView: T.SalesBreakdownView;
}

const initialState: ReportFiltersState = {
  dateFilter: 'Today',
  salesBreakdownView: 'channel',
};

export default function reportFiltersReducer(
  state = initialState,
  action: ReportFiltersAction
): ReportFiltersState {
  switch (action.type) {
    case T.SET_REPORT_DATE_FILTER:
      return { ...state, dateFilter: action.payload };
    case T.SET_SALES_BREAKDOWN_VIEW:
      return { ...state, salesBreakdownView: action.payload };
    default:
      return state;
  }
}
